module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG51351baf733a2b77435be34c233dbfef.51351baf.png";